import React, { useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import ChildAccountList from '../../../components/Multi/ChildAccount/AccountList';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import CreateButton from '../../../components/Tools/CreateButton';
import MainFilter from '../../../components/Tools/MainFilter';
import DashboardFilter from '../../Dashboard/components/DashboardFilter';

const ChildAccountListPage = () => {
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [open, setOpen] = useState(false);
    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: ""
    });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleFilterClick = async () => {
        setOpen(false);
    };
    
    const handleInput = async (e) => {
      const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        const newPayload = {
        ...filterPayload,
        [name]: "",
        };
        setFilterPayload(newPayload);
    }


    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                 <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Bank Accounts</h4>
                        <CustomBreadcrumbs linksArray={[]} title="Bank Accounts"/>
                    </div>
                </div>
                <DashboardFilter 
                    openFilterModal={setOpen} 
                    filterPayload={filterPayload} 
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <ChildAccountList searchStr={filterPayload.searchStr} tier={filterPayload.tier}/>
            </div>
            { authData.user.user_type === 'l3' && <CreateButton title={"Add Bank Account"} url={"/addchildAccount"}/> }

            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen}
                filterPayload={filterPayload}
                handleFilterClick={handleFilterClick}
                isDepartmentRequired={false}
            />
        </div>
    )
}
export default ChildAccountListPage
